import { UserPreferences } from "@/store/modules"
import { deepClone } from "@/utility"
import {
  ENROLLMENT_CONFIRMATION_SUPPLY_SHED_TABLE,
  DEFAULT_TABLE_PREFERENCES
} from "@/constants/preferences"

const updateLocalStorage = (data) => {
  localStorage.setItem('preferences', JSON.stringify(data))
}

const DEFAULT_PREFERENCES = {}
DEFAULT_PREFERENCES[ENROLLMENT_CONFIRMATION_SUPPLY_SHED_TABLE] = deepClone(DEFAULT_TABLE_PREFERENCES)

const state = deepClone(DEFAULT_PREFERENCES)
const getters = {}
const mutations = {
  [UserPreferences.Mutations.setEntireUserPreferences](state, { preferences }) {
    Object.assign(state, preferences)
  },
  [UserPreferences.Mutations.setPreferenceKeyData](state, { preferenceKey, data }) {
    state[preferenceKey] = data
    updateLocalStorage(state)
  }
}

const actions = {
  [UserPreferences.Actions.initializePreferences]({ state, commit }) {
    const preferences = JSON.parse(localStorage.getItem('preferences')) || {}

    for (const key in state) {
      if (preferences[key] == null) preferences[key] = state[key]
    }

    localStorage.setItem('preferences', JSON.stringify(preferences))
    commit(UserPreferences.Mutations.setEntireUserPreferences, { preferences })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
